export enum Color {
  RED = 'RED',
  BLUE = 'BLUE',
  // add more when backend adds them
}

export enum Size {
  XXS = 'XXS',
  XS = 'XS',
  S = 'S',
  M = 'M',
  L = 'L',
  XL = 'XL',
  XXL = 'XXL',
  XXXL = 'XXXL',
}
